import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react"; // Install using: npm install qrcode.react
import { FaCopy } from "react-icons/fa6";
import toast, { Toaster } from "react-hot-toast";

const QR = ({ multisigwallet, isQrVisible, setIsQrVisible }) => {
  const sucess = (msg) => toast.success(msg);
  const closeQR = () => {
    setIsQrVisible(false);
  };

  const sliceAddress = (address) => {
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  function copyAddress(address) {
    navigator.clipboard
      .writeText(address)
      .then(() => {
        sucess("Address copied to clipboard!"); // Optional: Show a notification
      })
      .catch((err) => {});
  }

  return (
    <div>
      {/* QR Code Popup */}
      {isQrVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={closeQR} // Close QR popup on overlay click
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()} // Prevent closing popup when clicking inside
          >
            <QRCodeCanvas value={multisigwallet} size={200} />
            <div
              className="m-1 t-a-c "
              style={{ cursor: "pointer",
                 display: "flex",
                justifyContent:"center"
                }}
            >
             <span className="m-1"> {sliceAddress(multisigwallet)}{" "}</span>
              <div className="m-1">
                <FaCopy size={15} onClick={() => copyAddress(multisigwallet)} />
              </div>
            </div>
            <Toaster />
          </div>
        </div>
      )}
    </div>
  );
};

export default QR;
